export function first(gauge) {
  const { queries } = gauge
  return queries[0].result
}
